export default __webpack_public_path__ + "static/ImageBerthe-4575fbbcfedd76a59df34a73cf0190fb.png";